<template>
<div class="d-flex whiteCard" :class="className" :style="combinedStyles">
    <div class="notDashedContainer">
      <div class="notDashedContainerInner" :style="combinedInnerStyles">
        <div class="w-100 position-relative flex-wrap min-height-adjustment">
          <template v-for="field in fields" :key="field.id">
            <componentRenderer
              :class="field.properties.grid ? `col-lg-${field.properties.grid.columns}`: ''"
              :field="field"
              v-on:component-updated="updated"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import componentRenderer from "@/components/component-renderer";
import _ from 'lodash';

export default {
  name: "card-bucket",
  components: { componentRenderer },
  data () {
    return {
      cssString: "",
      innerContainerCssString: ""
    }
  },
  props: {
    fieldId: String,
    requires: Array,
    fields: {
      type: Array,
      required: true
    },
    grid: {
      type: Object
    },
    noRow: {
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      default: () => {
        return {};
      }
    },
    innerStyles: {
      type: Object,
      default: () => {
        return {};
      }
    },
    className: {
      type: String
    }
  },
  methods: {
    updated (field, properties) {
      if (!field || !field.fieldId) {
        return;
      }

      let updatedField = _.find(this.fields, function (fld) {
        return fld.fieldId === field.fieldId;
      });

      if (updatedField) {
        updatedField.properties = { ...updatedField.properties, ...properties };

        if (this.fieldId) {
          this.$store.dispatch("setComponentStatus", {
            component: this.fieldId,
            status: true
          });
        }
      } else {
        return
      }
    }
  },
  computed: {
    combinedStyles () {
      let styleStr = '';
      if (this.styles) {
        Object.entries(this.styles).forEach(([key, value]) => {
          styleStr += `${key}:${value};`;
        });
      }
      return styleStr + this.cssString;
    },
    combinedInnerStyles () {
      let styleStr = '';
      if (this.innerStyles) {
        Object.entries(this.innerStyles).forEach(([key, value]) => {
          styleStr += `${key}:${value};`;
        });
      }
      return styleStr + this.innerContainerCssString;
    }
  }
};
</script>
<style scoped lang="scss">
.min-height-adjustment{
  min-height: 200px;
  @media(max-width: 768px){
    min-height: 100px;
  }
}
@media (min-width: 992px) {
  .desktop {
    display: block;
  }

  .mobile {
    display: none;
  }
}
@media (max-width: 991px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: block;
  }
}

</style>
